import Vue from 'vue'
import Router from 'vue-router'


// import AppHome from '@/components/main/AppHome'

import AppArticle from '../components/main/AppArticle'
import AppHome from '../components/main/AppHome'
import FunListMaintain from '../components/function/inursingsys/FunListMaintain'
import IRegSetting from '../components/function/inursingsys/IRegSetting'
import RegNote from '../components/function/inursingsys/RegNote'
import ClinicA from '../components/function/iregsys/ClinicA'
import ClinicB from '../components/function/iregsys/ClinicB'
import ClinicC from '../components/function/iregsys/ClinicC'
import DoctorMaintain from '../components/function/iregsys/DoctorMaintain'
import VersionInfo from '../components/function/iregsys/VersionInfo'
import RegTan from '../components/function/iregsys/RegTan'
import RegDaan from '../components/function/iregsys/RegDaan'
import RegKsph from '../components/function/iregsys/RegKsph'
import HospDocMaintain from '../components/function/iregsys/HospDocMaintain'
import ClinicD from '../components/function/iregsys/ClinicD'
import HospA from '../components/function/iregsys/HospA'
import DivA from '../components/function/iregsys/DivA'
import ClinicNoSearch from '../components/function/iregsys/ClinicNoSearch'
import RegSearchCancel from '../components/function/iregsys/RegSearchCancel'
import HospB from '../components/function/iregsys/HospB'
import DivB from '../components/function/iregsys/DivB'
import DocDivRegSearch from '../components/function/iregsys/DocDivRegSearch'
import BedUsageRate from '../components/function/iregsys/BedUsageRate'
import RegSuccess from '../components/function/iregsys/RegSuccess'
import HospC from '../components/function/iregsys/HospC'
import HospD from '../components/function/iregsys/HospD'
import DivC from '../components/function/iregsys/DivC'
import DivD from '../components/function/iregsys/DivD'
import RegCondSetting from '../components/function/iregsys/RegCondSetting'
import AddReg from '../components/function/iregsys/AddReg'
import NewsPage from '../components/function/iregsys/NewsPage'
import RedirectTan from '../components/function/iregsys/RedirectTan'
import VersionInfoSimple from '../components/function/iregsys/VersionInfoSimple'
import RegUserMaintain from '../components/function/iregsys/RegUserMaintain'
import ModiMaintainPass from '../components/function/iregsys/ModiMaintainPass'
import CheckSpecialPatient from '../components/function/iregsys/CheckSpecialPatient'
import NewsMaintain from '../components/function/iregsys/NewsMaintain'
import DoctorIntroduction from '../components/function/iregsys/DoctorIntroduction'
import NewsSlide from '../components/function/iregsys/NewsSlide'
import RedirectURL from '../components/function/iregsys/RedirectURL'
import MaintainLog from '../components/function/iregsys/MaintainLog'
import SelfDivSetting from '../components/function/iregsys/SelfDivSetting'
import RegtimeExcludeSetting from '../components/function/iregsys/RegtimeExcludeSetting'
import ClinicNoteMaintain from '../components/function/iregsys/ClinicNoteMaintain'
import ClinicChkMaintain from '../components/function/iregsys/ClinicChkMaintain'
import MemoPage from '../components/function/iregsys/MemoPage'
import BedUsageRateV2 from '../components/function/iregsys/BedUsageRateV2'
import PrivacyPolicy from '../components/function/iregsys/PrivacyPolicy'

//首頁
import IndexSHS from '../components/function/iregsys/IndexSHS'
//--- for test ----
import ErrorSample from '../components/function/inursingsys/ErrorSampleCode'


Vue.use(Router);
/**
 * Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location:
 * 避免點同一路徑出現erro 錯誤 110/09/17 新增
 * **/
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}


//mode:'history',
//base:'/iNursingSys',
export default new Router({

  routes: [
      {
          path: '/errorsample',
          name: 'errorsample',
          component : ErrorSample
      },
      {name:'RedirectTan', path:'/redirecttan/:url?/:divCode?',component:RedirectTan},//切換至四季台安 芯四季 科別連結 110/02/18
      {
          path:'/',
          component: AppHome,
          children:[
              {name:'AppArticle', path:'', component:AppArticle},
              {name:'FunListMaintain', path:'funlistmaintain',component:FunListMaintain},
              {name:'IRegSetting', path:'iregsetting',component:IRegSetting},
              {name:'RegNote', path:'regnote',component:RegNote},
              {name:'ClinicA', path:'clinica/:divCode?',component:ClinicA},
              {name:'ClinicB', path:'clinicb/:divCode?',component:ClinicB},
              {name:'ClinicC', path:'clinicc/:divCode?',component:ClinicC},
              {name:'DoctorMaintain', path:'doctormaintain',component:DoctorMaintain},
              {name:'VersionInfo', path:'versioninfo',component:VersionInfo},
              {name:'RegTan', path:'regtan',component:RegTan},
              {name:'RegDaan', path:'regdaan',component:RegDaan},
              {name:'RegKsph', path:'regksph',component:RegKsph},
              {name:'HospDocMaintain', path:'hospdocmaintain',component:HospDocMaintain},
              {name:'ClinicD', path:'clinicd/:divCode?',component:ClinicD},
              {name:'HospA', path:'hospa',component:HospA},
              {name:'DivA', path:'diva/:divCode?/:selfDiv?',component:DivA},
              {name:'ClinicNoSearch', path:'clinicnosearch',component:ClinicNoSearch},
              {name:'RegSearchCancel', path:'regsearchcancel',component:RegSearchCancel},
              {name:'HospB', path:'hospb',component:HospB},
              {name:'DivB', path:'divb/:divCode?/:selfDiv?',component:DivB},
              {name:'DocDivRegSearch', path:'docdivregsearch',component:DocDivRegSearch},
              {name:'BedUsageRate', path:'bedusagerate',component:BedUsageRate},
              {name:'RegSuccess', path:'regsuccess',component:RegSuccess},
              {name:'HospC', path:'hospc',component:HospC},
              {name:'HospD', path:'hospd',component:HospD},
              {name:'DivC', path:'divc/:divCode?/:selfDiv?',component:DivC},
              {name:'DivD', path:'divd/:divCode?/:selfDiv?',component:DivD},
              {name:'RegCondSetting', path:'regcondsetting',component:RegCondSetting},
              {name:'AddReg', path:'addreg',component:AddReg},
              {name:'NewsPage', path:'newspage',component:NewsPage},
              {name:'VersionInfoSimple', path:'versioninfosimple',component:VersionInfoSimple},
              {name:'RegUserMaintain', path:'regusermaintain',component:RegUserMaintain},
              {name:'ModiMaintainPass', path:'modimaintainpass',component:ModiMaintainPass},
              {name:'CheckSpecialPatient', path:'checkspecialpatient',component:CheckSpecialPatient},
              {name:'NewsMaintain', path:'newsmaintain',component:NewsMaintain},
              {name:'DoctorIntroduction', path:'doctorintroduction',component:DoctorIntroduction},
              {name:'NewsSlide', path:'newsslide',component:NewsSlide},
              {name:'RedirectURL', path:'redirecturl',component:RedirectURL},
              {name:'MaintainLog', path:'maintainlog',component:MaintainLog},
              {name:'IndexSHS', path:'indexshs',component:IndexSHS},
              {name:'SelfDivSetting', path:'selfdivsetting',component:SelfDivSetting},
              {name:'RegtimeExcludeSetting', path:'regtimeexcludesetting',component:RegtimeExcludeSetting},
              {name:'ClinicNoteMaintain', path:'clinicnotemaintain',component:ClinicNoteMaintain},
              {name:'ClinicChkMaintain', path:'clinicchkmaintain',component:ClinicChkMaintain},
              {name:'MemoPage', path:'memopage',component:MemoPage},
              {name:'BedUsageRateV2', path:'bedusageratev2',component:BedUsageRateV2},
              {name:'PrivacyPolicy', path:'privacypolicy',component:PrivacyPolicy},


          ]

      }
  ]
})
